import request from '@/utils/request';

export function getMessageIndex() {
  return request({
    url: '/Message/index',
  });
}

export function getMessageList(params, silentRequest = true) {
  return request({
    url: '/Message/getList',
    params,
    silentRequest,
  });
}

export function getConversationInfo(userId) {
  return request({
    url: '/Message/conversation',
    params: {
      userId,
    },
  });
}

export function replyConversation(userId, content, messageType) {
  return request({
    url: '/Message/replyConversation',
    params: {
      userId,
      content,
      type: messageType,
    },
  });
}

export function getNotificationList(type) {
  return request({
    url: '/Message/getNotificationList',
    params: {
      type,
    },
  });
}
